module.exports = __webpack_public_path__ + "static/media/event.1bcbc38c.webp";